module.exports = __webpack_public_path__ + "media/bangkok/bangkok gold-c778beb9.jpg";